export function getSidenavTranslations(favoritesGroupName: string) {
    return {
        en: {
            'SiDENAV.ORGANIZATION.CONNECT': 'Connect to organization',
            'SiDENAV.ORGANIZATION.DISCONNECT': 'Disconnect from organization',
            [favoritesGroupName]: 'Favorite',
            'apps': 'Applications',
            'analytics': 'Analytics',
            'administration': 'Administration',
            'config': 'Configuration',
            'management': 'Management',
        },
        ru: {
            'SiDENAV.ORGANIZATION.CONNECT': 'ÐÐ¾Ð´ÐºÐ»ÑÑÐ¸ÑÑÑÑ Ðº ÑÐ°Ð¹ÑÑ',
            'SiDENAV.ORGANIZATION.DISCONNECT': 'ÐÑÐºÐ»ÑÑÐ¸ÑÑÑÑ Ð¾Ñ ÑÐ°Ð¹ÑÐ°',
            [favoritesGroupName]: 'ÐÐ·Ð±ÑÐ°Ð½Ð½Ð¾Ðµ',
            'apps': 'ÐÑÐ¸Ð»Ð¾Ð¶ÐµÐ½Ð¸Ñ',
            'analytics': 'ÐÐ½Ð°Ð»Ð¸ÑÐ¸ÐºÐ°',
            'administration': 'ÐÐ´Ð¼Ð¸Ð½Ð¸ÑÑÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ',
            'config': 'ÐÐ¾Ð½ÑÐ¸Ð³ÑÑÐ°ÑÐ¸Ð¸',
            'management': 'Ð£Ð¿ÑÐ°Ð²Ð»ÐµÐ½Ð¸Ðµ'
        }
    };
}
